
<template>
  <div v-bind:id="'qrcode' + getId()" v-bind:class="element.animation" style="position:relative;">
    <div class="speech-bubble col-12">
      <div class="row">
        <div class="col-12">QR code</div>
        <div class="col-12"><img v-bind:src="element.src" width="100%" /></div>
      </div>
      
    </div>
    <div class="qrcode-button col-12 mt-3" @click="print">
      Print
    </div>
  </div>
  
</template>

<script>
  export default {
    name: 'onboarding-qrcode',
    components: {
    },
    props: {
      element: {
        required: false,
        type: Object,
        default() {
          return { extra: null, animation: "" }
        }
      },
      removable: {
        required: false,
        type: Boolean,
        default: false
      },
      step: {
        required: false,
        type: Object,
        default() {
          return null
        }
      },
    },
    data() {
      return {
      }
    },
    methods: {
      print() {
        this.printQRCode()
      },
      remove() {
        //this.$emit("removeanswer", this.element, this.step)
      },
      getId() {
        return this._uid;
      },
      hide() {
        $('#qrcode' + this.getId()).hide();
      },
      show() {
        $('#qrcode' + this.getId()).show();
      },
      clicked() {
        if (this.element.goto) {
          this.$emit("goto", this.element.goto)
        }
      },
      /**
       * https://stackoverflow.com/questions/2909033/using-javascript-to-print-images
       * Prints an image by temporarily opening a popup
       * @param {string} src - image source to load
       * @returns {void}
       */
      printQRCode(src) {
        var title = this.name;
        var description = this.description;
        var win = window.open('about:blank', "_new");
        win.document.open();
        //'   <body onload="window.print()" onafterprint="window.close()">',
        var content = [
          '<html>\n',
          '   <head>\n',
          '   <link href="/assets/css/all.css" rel="stylesheet" type="text/css">\n',
          ('   <scr' + 'ipt src="/global_assets/js/main/jquery.min.js"></scr' + 'ipt>\n'),
          ('   <scr' + 'ipt src="/resources/dist/build.js"></scr' + 'ipt>\n'),
          ('   <scr' + 'ipt src="/resources/dist/vuex.js"></scr' + 'ipt>\n'),
          ('   <scr' + 'ipt src="/Scripts/vue-i18n/vue-i18n.js"></scr' + 'ipt>\n'),
          '   </head>\n',
          '   <body>\n',
          '   <div class="container-fluid" id="app">\n',
          '   <div class="row col-12">\n',
          '   <qrcode-advanced-print></qrcode-advanced-print>\n',
          '   </div>\n',
          '   </div>\n',
          '<scr',
          'ipt',
          '>\n',
          'const i18n = new VueI18n({\n',
          '  locale: "en", // set locale\n',
            '});\n',
          'var vueContent = {\n',
          'i18n,\n',
          'created: function () {\n',
          '  window.$eventBus.$i18n.locale = "en"\n',
          '\n},',
          'mounted: function () {},\n',
          'el: "#app",\n',
          '}\n',
          'var vm = new Vue(vueContent).$mount("#app");\n',
          '</s',
          'cript>\n',
          '   </body>\n',
          '</html>\n'].join('');

        //alert(content)
        win.document.write(content);
        win.document.close();
      },
    },
    created() {

    },
    mounted() {

    }
  }
</script>

<style scoped>

  .speech-bubble {
    position: relative;
    background: #f7f7f7;
    border-radius: .4em;
    padding-top: 20px;
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 20px;
    font-size: 24px;
    color: black;
    float: left;
    left: 30px;
    max-width: 60%;
  }

    .speech-bubble:after {
      content: '';
      position: absolute;
      left: 1px;
      top: 50%;
      width: 0;
      height: 0;
      border: 45px solid transparent;
      border-right-color: #f7f7f7;
      border-left: 0;
      border-bottom: 0;
      margin-top: -22.5px;
      margin-left: -45px;
    }


  .qrcode-button {
    position: relative;
    border-radius: .4em;
    padding-top: 20px;
    padding-left: 40px;
    padding-right: 40px;
    padding-bottom: 20px;
    font-size: 24px;
    color: white;
    float: left;
    left: 30px;
    max-width: 60%;
    background: #349526;
    cursor: pointer;
  }

 

  @media (max-width: 768px) {
  }

  .delay-1 {
    animation-delay: 1s;
  }

  .delay-2 {
    animation-delay: 2s;
  }

  .delay-3 {
    animation-delay: 3s;
  }

  .delay-4 {
    animation-delay: 4s;
  }


  .duration-1 {
    animation-duration: 1s;
  }

  .duration-2 {
    animation-duration: 2s;
  }

  .duration-3 {
    animation-duration: 3s;
  }

  .duration-4 {
    animation-duration: 4s;
  }

  .duration-5 {
    animation-duration: 5s;
  }

  .duration-6 {
    animation-duration: 6s;
  }

  .duration-7 {
    animation-duration: 7s;
  }

  .duration-8 {
    animation-duration: 8s;
  }

  .duration-9 {
    animation-duration: 9s;
  }

  .duration-10 {
    animation-duration: 10s;
  }
</style>



// WEBPACK FOOTER //
// src/components/onboarding/onboarding-qrcode.vue